import { render, staticRenderFns } from "./PlayerVipLimitForm.vue?vue&type=template&id=3446b481&"
import script from "./PlayerVipLimitForm.vue?vue&type=script&lang=js&"
export * from "./PlayerVipLimitForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports